import { Text } from 'components/ui';
import AuthExtraActions from 'pages/Auth/components/AuthExtraActions';
import { AuthStatusPanelProps } from './AuthStatusPanel.props';
import {
  AuthStatusPanelContentWrap,
  AuthStatusPanelIconWrap,
  AuthStatusPanelMainActionWrap,
  AuthStatusPanelRoot,
} from './AuthStatusPanel.styles';

const AuthStatusPanel = ({
  description,
  descriptionSx,
  extraAction,
  icon,
  iconBackgroundColor,
  iconColor,
  mainAction,
  title,
  titleSx,
}: AuthStatusPanelProps) => (
  <AuthStatusPanelRoot>
    <AuthStatusPanelIconWrap sx={{ backgroundColor: iconBackgroundColor, color: iconColor }}>
      {icon}
    </AuthStatusPanelIconWrap>
    <AuthStatusPanelContentWrap spacing={1}>
      <Text component="h2" sx={titleSx} variant="h3">
        {title}
      </Text>
      {description ? (
        <Text color="text.secondary" sx={descriptionSx} variant="body2">
          {description}
        </Text>
      ) : null}
    </AuthStatusPanelContentWrap>
    {mainAction ? <AuthStatusPanelMainActionWrap>{mainAction}</AuthStatusPanelMainActionWrap> : null}
    <AuthExtraActions>{extraAction}</AuthExtraActions>
  </AuthStatusPanelRoot>
);

export default AuthStatusPanel;
